
(function () {
  'use strict';

  var syncTimer;
  var syncing = false;
  var dispatchLocation = '';
  var locationPromise;
  var lastRenderSignature = '';
  var productCache = {};

  function parseJson(id) {
    var node = document.getElementById(id);
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function getConfig() {
    var defaults = parseJson('VivarroCartDefaults') || {};
    var template = parseJson('VivarroTemplateUpsells');
    if (template && Array.isArray(template.products)) {
      defaults.title = template.title || defaults.title;
      defaults.button = template.button || defaults.button;
      defaults.products = template.products;
    }
    return defaults;
  }

  function visibleCartItems(config, cart) {
    var protectionId = config.protection && String(config.protection.variantId || '');
    return (cart.items || []).filter(function (item) {
      return String(item.variant_id) !== protectionId;
    });
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: currency || 'MXN',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function productData(handle) {
    if (!handle) return Promise.resolve(null);
    if (Object.prototype.hasOwnProperty.call(productCache, handle)) return productCache[handle];

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Product request failed');
        return response.json();
      })
      .catch(function () { return null; });

    return productCache[handle];
  }

  function enrichCartItems(cart) {
    return Promise.all((cart.items || []).map(function (item) {
      return productData(item.handle).then(function (product) {
        if (!product || !Array.isArray(product.variants)) return;
        var variant = product.variants.find(function (candidate) {
          return String(candidate.id) === String(item.variant_id);
        });
        item.vivarro_compare_at_price = variant ? Number(variant.compare_at_price || 0) : 0;
      });
    })).then(function () { return cart; });
  }

  function discountTitles(item) {
    var titles = [];

    (item.discounts || []).forEach(function (discount) {
      if (discount && discount.title) titles.push(String(discount.title));
    });

    (item.line_level_discount_allocations || []).forEach(function (allocation) {
      var application = allocation && allocation.discount_application;
      if (application && application.title) titles.push(String(application.title));
    });

    return titles.filter(function (title, index) {
      return titles.indexOf(title) === index;
    });
  }

  function discountBadges(item) {
    var titles = discountTitles(item);
    if (!titles.length) return '';

    return '<div class="vivarro-cart-item__offers" aria-label="Ofertas aplicadas">' +
      titles.map(function (title) {
        return '<span class="vivarro-cart-offer">' +
          '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true">' +
            '<path d="M20.6 13.8 10.2 3.4H4v6.2L14.4 20a2 2 0 0 0 2.8 0l3.4-3.4a2 2 0 0 0 0-2.8Z" fill="currentColor"/>' +
            '<circle cx="7.5" cy="7.5" r="1.35" fill="#fff"/>' +
          '</svg><span>' + escapeHtml(title) + '</span></span>';
      }).join('') +
    '</div>';
  }

  function itemReferenceTotal(item) {
    var current = Number(item.final_line_price != null ? item.final_line_price : item.line_price) || 0;
    var original = Number(item.original_line_price || 0);
    var compareAt = Number(item.vivarro_compare_at_price || 0) * Number(item.quantity || 0);
    return Math.max(current, original, compareAt);
  }

  function addBusinessDays(date, days) {
    var result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) added += 1;
    }
    return result;
  }

  function dispatchRange() {
    var start = addBusinessDays(new Date(), 1);
    var end = addBusinessDays(new Date(), 3);
    var startText = start.toLocaleDateString('es-MX', { day: 'numeric', month: 'long' });
    var endText = end.toLocaleDateString('es-MX', { day: 'numeric', month: 'long' });
    return startText + ' y el ' + endText;
  }

  function paintDispatch() {
    var node = document.getElementById('VivarroDispatch');
    if (!node) return;
    node.innerHTML = '<span aria-hidden="true">🚚</span> <strong>Envío gratis con seguimiento a todo México</strong>';
  }

  function loadLocation(config) {
    if (locationPromise) return locationPromise;
    paintDispatch();
    locationPromise = Promise.resolve(config.country || 'México');
    return locationPromise;
  }

  function renderUpsells(config, cart) {
    var wrapper = document.getElementById('VivarroProductUpsells');
    if (!wrapper) return;
    var form = wrapper.closest('form.vivarro-cart');

    var inCart = {};
    (cart.items || []).forEach(function (item) {
      inCart[String(item.variant_id)] = true;
    });

    var cartHandles = {};
    visibleCartItems(config, cart).forEach(function (item) {
      cartHandles[String(item.handle || '')] = true;
    });

    var products = (config.products || []).filter(function (product) {
      if (!product || !product.available || inCart[String(product.variantId)]) return false;
      var triggers = Array.isArray(product.triggerHandles) ? product.triggerHandles : [];
      return triggers.some(function (handle) {
        return cartHandles[String(handle)];
      });
    }).slice(0, 2);

    var signature = products.map(function (product) {
      return product.variantId;
    }).join('|');

    if (!products.length) {
      if (form) form.classList.add('vivarro-cart--no-upsells');
      wrapper.hidden = true;
      wrapper.innerHTML = '';
      wrapper.dataset.signature = '';
      return;
    }

    if (form) form.classList.remove('vivarro-cart--no-upsells');
    if (wrapper.dataset.signature === signature) return;

    var html = '<h3 class="vivarro-upsells__title">' +
      escapeHtml(config.title || 'Nuestros clientes también compran') +
      '</h3><div class="vivarro-upsells__list">';
    var addLabel = String(config.button || 'Agregar').replace(/\s*\+\s*$/, '') + ' +';

    products.forEach(function (product) {
      var compare = Number(product.compareAtPrice) > Number(product.price)
        ? '<span class="vivarro-upsell__compare">' + formatMoney(product.compareAtPrice, config.currency) + '</span>'
        : '';

      html += '<article class="vivarro-upsell">' +
        '<a class="vivarro-upsell__image" href="' + escapeHtml(product.url) + '">' +
          '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' +
        '</a>' +
        '<div class="vivarro-upsell__info">' +
          '<a class="vivarro-upsell__name" href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a>' +
          '<div class="vivarro-upsell__prices">' + compare +
            '<span class="vivarro-upsell__price">' + formatMoney(product.price, config.currency) + '</span>' +
          '</div>' +
          '<a class="vivarro-upsell__details" href="' + escapeHtml(product.url) + '">Mostrar más detalles</a>' +
        '</div>' +
        '<button type="button" class="vivarro-upsell__add" data-vivarro-upsell="' +
          escapeHtml(product.variantId) + '">' + escapeHtml(addLabel) + '</button>' +
      '</article>';
    });

    html += '</div>';
    wrapper.dataset.signature = signature;
    wrapper.innerHTML = html;
    wrapper.hidden = false;
  }


  function itemProperties(item) {
    var properties = item.properties || {};
    return Object.keys(properties).filter(function (key) {
      return key.charAt(0) !== '_' && properties[key];
    }).map(function (key) {
      return '<span class="ajaxcart__product-meta">' + escapeHtml(key) + ': ' +
        escapeHtml(properties[key]) + '</span>';
    }).join('');
  }

  function cartItemMarkup(item, currency) {
    var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<span class="ajaxcart__product-meta">' + escapeHtml(item.variant_title) + '</span>'
      : '';
    var currentPrice = Number(item.final_line_price != null ? item.final_line_price : item.line_price);
    var originalPrice = itemReferenceTotal(item);
    var price = originalPrice > currentPrice
      ? '<del class="ajaxcart__price">' + formatMoney(originalPrice, currency) + '</del>' +
        '<span class="ajaxcart__price">' + formatMoney(currentPrice, currency) + '</span>'
      : '<span class="ajaxcart__price">' + formatMoney(currentPrice, currency) + '</span>';

    return '<div class="ajaxcart__product fadeCartProducts vivarro-cart-item" data-variant-id="' +
      escapeHtml(item.variant_id) + '">' +
      '<div class="ajaxcart__row" data-line="' + escapeHtml(item.key) + '">' +
        '<div class="vivarro-cart-item__layout">' +
          '<a href="' + escapeHtml(item.url) + '" class="ajaxcart__product-image">' +
            '<img src="' + escapeHtml(item.image || '') + '" alt="' + escapeHtml(item.product_title || item.title) + '">' +
          '</a>' +
          '<div class="vivarro-cart-item__info">' +
            '<div class="vivarro-cart-item__top">' +
              '<div class="ajaxcart__product-name--wrapper">' +
                '<a href="' + escapeHtml(item.url) + '" class="ajaxcart__product-name">' +
                  escapeHtml(item.product_title || item.title) + '</a>' + variant + itemProperties(item) +
              '</div>' +
              '<button type="button" class="vivarro-cart-remove" data-vivarro-remove="' +
                escapeHtml(item.key) + '" aria-label="Eliminar producto">' +
                '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">' +
                  '<path d="M4 7h16M9 7V4h6v3m-8 0 1 13h8l1-13M10 11v5m4-5v5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
                '</svg>' +
              '</button>' +
            '</div>' +
            discountBadges(item) +
            '<div class="vivarro-cart-item__bottom">' +
              '<div class="vivarro-cart-item__price">' + price + '</div>' +
              '<div class="qtybox ajaxcart__qty">' +
                '<button type="button" class="ajaxcart__qty-adjust" data-vivarro-quantity="' +
                  escapeHtml(item.key) + '" data-qty="' + Math.max(0, Number(item.quantity) - 1) +
                  '" aria-label="Disminuir cantidad">−</button>' +
                '<input type="text" class="quantity-selector quantity-input ajaxcart__qty-num" value="' +
                  Number(item.quantity) + '" readonly aria-label="Cantidad">' +
                '<button type="button" class="ajaxcart__qty-adjust" data-vivarro-quantity="' +
                  escapeHtml(item.key) + '" data-qty="' + (Number(item.quantity) + 1) +
                  '" aria-label="Aumentar cantidad">+</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function protectionMarkup(config) {
    if (!config.protection || !config.protection.variantId) return '';
    return '<section class="vivarro-protection" aria-label="Protección de envío">' +
      '<button type="button" class="vivarro-protection__toggle" role="switch" aria-checked="false" ' +
        'aria-label="Agregar protección de envío" data-vivarro-protection-toggle data-variant-id="' +
        escapeHtml(config.protection.variantId) + '"></button>' +
      '<div class="vivarro-protection__copy">' +
        '<strong class="vivarro-protection__title">Protección de envío</strong>' +
      '</div>' +
      '<strong class="vivarro-protection__price">' +
        formatMoney(config.protection.price, config.currency) + '</strong>' +
    '</section>';
  }

  function renderDrawer(config, cart) {
    var container = document.getElementById('CartContainer');
    if (!container) return;

    var visibleItems = visibleCartItems(config, cart);
    var signature = (cart.token || '') + '|' + (cart.total_price || 0) + '|' +
      (cart.items || []).map(function (item) {
        return item.key + ':' + item.quantity + ':' + (item.final_line_price || item.line_price) + ':' +
          (item.vivarro_compare_at_price || 0) + ':' + discountTitles(item).join(',');
      }).join('|');

    if (container.dataset.vivarroSignature === signature &&
        (container.querySelector('form.vivarro-cart') || container.querySelector('.vivarro-cart-empty-state'))) return;

    if (!visibleItems.length) {
      container.innerHTML =
        '<div class="vivarro-cart-empty-state" role="status">' +
          '<span class="vivarro-cart-empty-state__icon" aria-hidden="true">🛒</span>' +
          '<strong>Tu carrito está vacío</strong>' +
        '</div>';
      container.dataset.vivarroSignature = signature;
      return;
    }

    var itemsHtml = visibleItems.map(function (item) {
      return cartItemMarkup(item, config.currency);
    }).join('');

    var saving = visibleItems.reduce(function (total, item) {
      var current = Number(item.final_line_price != null ? item.final_line_price : item.line_price) || 0;
      return total + Math.max(0, itemReferenceTotal(item) - current);
    }, 0);
    var savingHtml = saving > 0
      ? '<div class="vivarro-cart-summary__row vivarro-cart-summary__row--saving fadeCartTotal">' +
          '<span>Ahorra</span><strong>-' + formatMoney(saving, config.currency) + '</strong></div>'
      : '';

    container.innerHTML =
      '<form action="/cart" method="post" novalidate class="cart ajaxcart vivarro-cart">' +
        '<div class="ajaxcart__inner ajaxcart__inner--has-fixed-footer">' +
          itemsHtml +
          '<span class="vivarro-cart-loader" role="status" aria-label="Actualizando carrito"></span>' +
          '<section id="VivarroProductUpsells" class="vivarro-upsells" hidden aria-label="Productos recomendados"></section>' +
        '</div>' +
        '<div class="ajaxcart__footer ajaxcart__footer--fixed">' +
          '<div class="vivarro-cart-summary">' +
            savingHtml +
            '<div class="vivarro-cart-summary__row vivarro-cart-summary__row--total fadeCartTotal">' +
              '<span>Total</span><strong>' + formatMoney(cart.total_price, config.currency) + '</strong>' +
            '</div>' +
          '</div>' +
          protectionMarkup(config) +
          '<button type="submit" id="cart_checkout" class="cart__checkout fadeCartFooter vivarro-checkout" name="checkout">' +
            '<span class="vivarro-checkout__main">' +
              '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">' +
                '<path d="M7.5 10V7a4.5 4.5 0 0 1 9 0v3M6 10h12v10H6V10Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg><span>Finalizar compra</span>' +
            '</span>' +
            '<span class="vivarro-checkout__guarantee">' +
              '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">' +
                '<path d="M12 2.5 20 6v5.2c0 5.1-3.5 8.7-8 10.3-4.5-1.6-8-5.2-8-10.3V6l8-3.5Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>' +
                '<path d="m8.5 12 2.2 2.2 4.8-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg><span>Garantía de satisfacción de 60 días</span>' +
            '</span>' +
          '</button>' +
          '<p id="VivarroDispatch" class="vivarro-dispatch fadeCartFooter">🚚 Envío gratis con seguimiento a todo México</p>' +
        '</div>' +
      '</form>';

    container.dataset.vivarroSignature = signature;
  }

  function syncProtection(config, cart) {
    var toggle = document.querySelector('[data-vivarro-protection-toggle]');
    if (!toggle || !config.protection || !config.protection.variantId) return;

    var selected = (cart.items || []).some(function (item) {
      return String(item.variant_id) === String(config.protection.variantId);
    });

    toggle.setAttribute('aria-checked', selected ? 'true' : 'false');
    toggle.setAttribute('aria-label', selected ? 'Quitar protección de envío' : 'Agregar protección de envío');

    document.querySelectorAll('.vivarro-cart-item[data-variant-id]').forEach(function (row) {
      row.classList.toggle(
        'vivarro-cart-item--protection',
        String(row.dataset.variantId) === String(config.protection.variantId)
      );
    });
  }

  function updateCount(config, cart) {
    var count = document.getElementById('VivarroCartCount');
    var quantity = visibleCartItems(config, cart).reduce(function (total, item) {
      return total + Number(item.quantity || 0);
    }, 0);
    if (count) count.textContent = '(' + quantity + ')';
  }

  function removeOrphanProtection(config, cart) {
    var protectionId = config.protection && String(config.protection.variantId || '');
    if (!protectionId || visibleCartItems(config, cart).length) return Promise.resolve(cart);

    var protectionLine = (cart.items || []).find(function (item) {
      return String(item.variant_id) === protectionId;
    });
    if (!protectionLine) return Promise.resolve(cart);

    return changeLine(protectionLine.key, 0).then(enrichCartItems);
  }

  function fetchCart() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    });
  }

  function syncDrawer() {
    if (!document.getElementById('CartDrawer')) return Promise.resolve();
    if (syncing) {
      return new Promise(function (resolve) {
        window.setTimeout(resolve, 100);
      }).then(syncDrawer);
    }
    syncing = true;
    var config = getConfig();

    return fetchCart()
      .then(enrichCartItems)
      .then(function (cart) {
        return removeOrphanProtection(config, cart);
      })
      .then(function (cart) {
        renderDrawer(config, cart);
        updateCount(config, cart);
        renderUpsells(config, cart);
        syncProtection(config, cart);
        paintDispatch(config);
        loadLocation(config);
      })
      .catch(function () {})
      .finally(function () {
        syncing = false;
      });
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncDrawer, 80);
  }

  function reloadNativeCart() {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, 80);
    }).then(syncDrawer);
  }

  function setCartMutationLoading(control, loading) {
    var form = control && control.closest ? control.closest('form.vivarro-cart') : null;
    if (form) form.classList.toggle('vivarro-cart--updating', Boolean(loading));
    if (!control) return;
    if (loading) control.setAttribute('aria-busy', 'true');
    else control.removeAttribute('aria-busy');
  }

  function openVivarroDrawer() {
    [document.documentElement, document.body].forEach(function (node) {
      if (!node) return;
      node.classList.remove('js-drawer-open-left');
      node.classList.add('js-drawer-open', 'js-drawer-open-right');
    });

    var drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.setAttribute('tabindex', '-1');
  }

  function addVariant(variantId, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties: properties || {}
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to add item');
      return response.json();
    });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to change item');
      return response.json();
    });
  }

  document.addEventListener('click', function (event) {
    var quantityButton = event.target.closest('[data-vivarro-quantity]');
    var removeButton = event.target.closest('[data-vivarro-remove]');
    if (quantityButton || removeButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var control = quantityButton || removeButton;
      if (control.getAttribute('aria-busy') === 'true') return;
      control.setAttribute('aria-busy', 'true');
      changeLine(
        quantityButton ? quantityButton.dataset.vivarroQuantity : removeButton.dataset.vivarroRemove,
        quantityButton ? Number(quantityButton.dataset.qty) : 0
      ).then(function () {
        document.getElementById('CartContainer').dataset.vivarroSignature = '';
        syncDrawer();
      }).catch(function () {
        control.removeAttribute('aria-busy');
      });
      return;
    }

    var upsellButton = event.target.closest('[data-vivarro-upsell]');
    if (upsellButton) {
      event.preventDefault();
      if (upsellButton.getAttribute('aria-busy') === 'true') return;
      setCartMutationLoading(upsellButton, true);
      addVariant(upsellButton.dataset.vivarroUpsell)
        .then(reloadNativeCart)
        .catch(function () {})
        .finally(function () {
          setCartMutationLoading(upsellButton, false);
        });
      return;
    }

    var protectionToggle = event.target.closest('[data-vivarro-protection-toggle]');
    if (!protectionToggle) return;

    event.preventDefault();
    if (protectionToggle.getAttribute('aria-busy') === 'true') return;
    setCartMutationLoading(protectionToggle, true);

    var config = getConfig();
    fetchCart()
      .then(function (cart) {
        var line = (cart.items || []).find(function (item) {
          return String(item.variant_id) === String(config.protection.variantId);
        });

        if (line) return changeLine(line.key, 0);
        return addVariant(config.protection.variantId, { _vivarro_protection: 'true' });
      })
      .then(reloadNativeCart)
      .catch(function () {})
      .finally(function () {
        setCartMutationLoading(protectionToggle, false);
      });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (form.dataset.vivarroSubmitting === 'true') return;
    form.dataset.vivarroSubmitting = 'true';

    var submitButton = event.submitter || form.querySelector('[type="submit"][name="add"], [type="submit"]');
    var wasDisabled = submitButton ? submitButton.disabled : false;
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.classList.add('btn--loading');
    }

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (response.ok) return response.json();
        return response.json().catch(function () { return {}; }).then(function (error) {
          throw new Error(error.description || 'No se pudo agregar el producto al carrito.');
        });
      })
      .then(function () {
        var container = document.getElementById('CartContainer');
        if (container) container.dataset.vivarroSignature = '';
        return syncDrawer();
      })
      .then(openVivarroDrawer)
      .catch(function (error) {
        window.alert(error.message || 'No se pudo agregar el producto al carrito.');
      })
      .finally(function () {
        form.dataset.vivarroSubmitting = '';
        if (submitButton) {
          submitButton.disabled = wasDisabled;
          submitButton.removeAttribute('aria-busy');
          submitButton.classList.remove('btn--loading');
        }
      });
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest('.js-drawer-open-button-right, [href="/cart"]')) scheduleSync();
  });

  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    var observer = new MutationObserver(scheduleSync);
    observer.observe(drawer, { childList: true, subtree: true });
    scheduleSync();
  });

  function resetCheckoutLoading() {
    document.querySelectorAll('#CartDrawer .vivarro-checkout').forEach(function (button) {
      button.classList.remove('btn--loading');
      button.removeAttribute('aria-busy');
      button.disabled = false;
    });
  }

  window.addEventListener('pageshow', resetCheckoutLoading);
  window.addEventListener('focus', resetCheckoutLoading);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) resetCheckoutLoading();
  });
})();


/* Vivarro cart drawer: cierre delegado para contenido re-renderizado */
(function () {
  'use strict';

  function closeVivarroCart() {
    var openClasses = ['js-drawer-open', 'js-drawer-open-left', 'js-drawer-open-right'];

    [document.documentElement, document.body].forEach(function (node) {
      if (!node) return;
      openClasses.forEach(function (className) {
        node.classList.remove(className);
      });
    });

    if (window.jQuery) {
      window.jQuery('.page-container').off('touchmove.drawer');
      window.jQuery(document).off('focusin.drawer');
    }

    var cartTrigger = document.querySelector('a[href="/cart"]');
    if (cartTrigger && typeof cartTrigger.focus === 'function') {
      try {
        cartTrigger.focus({ preventScroll: true });
      } catch (error) {
        cartTrigger.focus();
      }
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;

    var closeButton = event.target.closest('#CartDrawer .js-drawer-close');
    var overlay = event.target.closest('.blur_open_drawer');

    if (!closeButton && !overlay) return;

    event.preventDefault();
    event.stopPropagation();
    closeVivarroCart();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeVivarroCart();
  });
})();


/* Vivarro cart drawer: el icono abre el drawer sin navegar a /cart */
(function () {
  'use strict';

  function openVivarroCart() {
    [document.documentElement, document.body].forEach(function (node) {
      if (!node) return;
      node.classList.remove('js-drawer-open-left');
      node.classList.add('js-drawer-open', 'js-drawer-open-right');
    });

    var drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.setAttribute('tabindex', '-1');
  }

  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;

    var cartLink = event.target.closest('a[href="/cart"]');
    if (!cartLink || cartLink.closest('#CartDrawer')) return;
    if (document.body.classList.contains('template-cart')) return;

    event.preventDefault();
    event.stopPropagation();
    openVivarroCart();
  }, true);
})();


/* Vivarro cart drawer: activador estable para aperturas repetidas */
(function () {
  'use strict';

  function prepareCartTriggers() {
    if (document.body.classList.contains('template-cart')) return;

    document.querySelectorAll('a[href="/cart"], a[data-vivarro-cart-trigger]').forEach(function (link) {
      if (link.closest('#CartDrawer')) return;
      link.setAttribute('data-vivarro-cart-trigger', '');
      link.setAttribute('href', '#CartDrawer');
      link.setAttribute('aria-controls', 'CartDrawer');
      link.setAttribute('aria-haspopup', 'dialog');
    });
  }

  function openPreparedCart() {
    [document.documentElement, document.body].forEach(function (node) {
      if (!node) return;
      node.classList.remove('js-drawer-open-left');
      node.classList.add('js-drawer-open', 'js-drawer-open-right');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareCartTriggers);
  } else {
    prepareCartTriggers();
  }

  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;

    var trigger = event.target.closest('[data-vivarro-cart-trigger]');
    if (!trigger) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    openPreparedCart();
  }, true);
})();
